
import React from "react";
import {
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Stack,
  Box,
} from "@mui/material";
import { renderFilterValue, MenuProps } from "../utils/rtmUtils";

const AnalyticsFilterBar = ({ filters, options, onFilterChange }) => {
  const handleToggle = (name, value, allOptions) => {
    let newValue = typeof value === "string" ? value.split(",") : value;
    
    if (newValue.includes("All")) {
      if (newValue[newValue.length - 1] === "All" || newValue.length === allOptions.length) {
        newValue = ["All"];
      } else {
        newValue = newValue.filter(v => v !== "All");
      }
    }
    
    if (newValue.length === 0) {
      newValue = ["All"];
    }

    onFilterChange(name, newValue);
  };

  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap sx={{ mb: 3 }}>
      {Object.keys(filters).map((key) => {
        const label = key.charAt(0).toUpperCase() + key.slice(1);
        const currentOptions = options[key] || ["All"];
        
        return (
          <FormControl key={key} size="small" sx={{ minWidth: 150 }}>
            <FormLabel sx={{ fontSize: "0.75rem", fontWeight: 600, mb: 0.5 }}>
              {label}
            </FormLabel>
            <Select
              multiple
              value={filters[key]}
              onChange={(e) => handleToggle(key, e.target.value, currentOptions)}
              renderValue={(selected) => renderFilterValue(selected)}
              MenuProps={MenuProps}
              sx={{ 
                bgcolor: "white",
                borderRadius: 2,
                "& .MuiSelect-select": { py: 1 }
              }}
            >
              {currentOptions.map((opt) => (
                <MenuItem key={opt} value={opt}>
                  <Checkbox checked={filters[key].indexOf(opt) > -1} size="small" />
                  <ListItemText primary={opt} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      })}
    </Stack>
  );
};

export default React.memo(AnalyticsFilterBar);
